<script setup>
import {useStore} from "vuex";
import { useRouter} from "vue-router";
import {onBeforeMount} from "vue";

const router = useRouter();
const store = useStore();

const closeModal = () => {
  const modal = bootstrap.Modal.getInstance(document.getElementById('logout_modal'));
  if (modal) {
    modal.hide();
    history.replaceState(null, null);
  }
}

const handlePopState = (event) => {
  if (event.state && event.state.modalOpen) {
    closeModal();
  } else {
    history.replaceState(null, null);
  }
}
window.addEventListener('popstate', handlePopState);

const deleteData = () => {
  store.dispatch("logout");
  router.push('/login');
}

onBeforeMount(() =>{
  window.removeEventListener('popstate', handlePopState);
})
</script>

<template>
  <li
    class="nav-item"
    @click="deleteData"
  >
    <a class="nav-link">
      <i class="nav-icon fas fa-door-open"></i>
<!--      <p>Выход</p>-->
    </a>
  </li>
<!--  <div-->
<!--    class="modal fade"-->
<!--    id="logout_modal"-->
<!--  >-->
<!--    <div class="modal-dialog">-->
<!--      <div class="modal-content">-->
<!--        <div class="modal-header">-->
<!--          <h5 class="modal-title">Вы уверены что хотите выйти?</h5>-->
<!--          <button-->
<!--            type="button"-->
<!--            class="btn-close"-->
<!--            data-bs-dismiss="modal"-->
<!--            aria-label="Close"-->
<!--          ></button>-->
<!--        </div>-->
<!--        <div class="modal-footer">-->
<!--          <button-->
<!--            type="button"-->
<!--            class="btn btn-danger"-->
<!--            data-bs-dismiss="modal"-->
<!--            @click="deleteData"-->
<!--          >-->
<!--            Да-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

</template>

<style scoped>

</style>